export const api = {
    base_url: 'https://api.kfachallenge.info/api/v1',
}